import React, { useEffect, useRef, useState } from 'react';
import './OurStrengths.css';

const OurStrengths = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing once animated
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of the component is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="strengths-section" ref={sectionRef}>
      <h2 className="strengths-title">Nos points forts</h2>
      <div className="strengths-container">
        <div className={`strength-card ${isVisible ? 'animate' : ''}`}>
          <img className="strength-icon" src="/images/strengths_quality.svg" alt="Quality Icon" />
          <h3 className="strength-card-title">Qualité des produits et services</h3>
          <p className="strength-card-description">
            Des emballages de qualité. Possibilité de stocker vos commandes.
          </p>
        </div>

        <div className={`strength-card ${isVisible ? 'animate' : ''}`}>
          <img className="strength-icon" src="/images/strengths_pen.svg" alt="Custom Icon" />
          <h3 className="strength-card-title">Sur Mesure</h3>
          <p className="strength-card-description">
            Nous vous proposons des emballages sur mesure, adaptés à votre activité.
          </p>
        </div>

        <div className={`strength-card ${isVisible ? 'animate' : ''}`}>
          <img className="strength-icon" src="/images/strengths_time.svg" alt="Delivery Icon" />
          <h3 className="strength-card-title">Livraison rapide</h3>
          <p className="strength-card-description">
            Vos emballages personnalisés seront livrés après une commande ferme entre 15 à 25 JOURS.
          </p>
        </div>
      </div>
      <div className="background-grid" />
      <div className="background-circle" />
    </section>
  );
};

export default OurStrengths;